import LocalizedStrings from 'react-localization';
import stringsJson from './localizedStrings.json';

let strings = new LocalizedStrings(stringsJson);

export default strings;
